<template>
  <ButtonComponent
    :icon="['fal', isValidContextualImages ? 'images' : 'exclamation-triangle']"
    :label="label"
    v-on="$listeners"
    class="shop-contextual-images-input"
    :class="{
      'shop-contextual-images-input--empty': !this.value.length,
      'shop-contextual-images-input--invalid': !isValidContextualImages,
    }"
  />
</template>

<script>
import { isValid } from './utils'

export default {
  props: {
    value: Array,
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['getItems'],
  computed: {
    isValidContextualImages() {
      if (!this.getItems || !this.value.length) return true

      const shopItems = this.getItems()
      return this.value.every(v => isValid(v, shopItems))
    },
    label() {
      if (!this.showLabel) return
      return this.$tc('xActiveContextualImages', this.value.length, { count: this.value.length })
    },
  },
}
</script>

<style lang="scss">
.shop-contextual-images-input {
  &--empty {
    .elder-button__label {
      opacity: 0.7;
    }
  }
  &--invalid {
    .elder-button__label {
      color: var(--error);
    }
    .elder-button__icon {
      color: var(--error);
    }
  }
}
</style>
